import React from 'react'
import { Modal } from '../../../UI/Modal'
import { DoorsTableTabs } from '../../../Cards/DoorSections/DoorsTableTabs'
import { TabbedDoorSectionProps } from '../../../Cards/DoorSections/types'

interface DoorsModalProps {
  show: boolean
  onHide: () => void
  chainData?: TabbedDoorSectionProps['chainData']
  chainID?: number
  forChainProxyId?: number
  chainName?: string
  subCategory: {
    name: string
    slug: string
    description: string
  }
  matchedTableComponent: TabbedDoorSectionProps['matchedTableComponent']
  matchedTableProps?: TabbedDoorSectionProps['matchedTableProps']
  matchedTableKey?: string
  unmatchedTableKeyPrefix: string
  className?: string
}

export function DoorsModal({
  show,
  onHide,
  chainData,
  chainID,
  forChainProxyId,
  chainName,
  subCategory,
  matchedTableComponent,
  matchedTableProps = {},
  matchedTableKey,
  unmatchedTableKeyPrefix,
  className = '',
}: DoorsModalProps) {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {chainName || chainData?.name} Doors
          {chainData?.count && (
            <span className="text-muted font-light ml-2">
              ({chainData.count} locations)
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DoorsTableTabs
          forChainProxyId={forChainProxyId}
          chainID={chainID}
          chainData={chainData}
          subCategory={subCategory}
          matchedTableComponent={matchedTableComponent}
          matchedTableProps={matchedTableProps}
          matchedTableKey={matchedTableKey}
          unmatchedTableKeyPrefix={unmatchedTableKeyPrefix}
          className={className}
        />
      </Modal.Body>
    </Modal>
  )
}
